import { graphql } from 'react-apollo'
import ChannelPartner from '/models/channel-partner'

#
# Queries
#

import index from './queries/index.gql'

export withChannelPartners = graphql index,
  options: (props)->
    { page, search } = props.location.state or {}
    variables:
      page: page or 1
      search: search or undefined
  props: ({props, data})->
    { nodes, pagination } = data.channel_partners or {}
    channelPartners: ChannelPartner.parse nodes or []
    channelPartnersPagination: pagination
    channelPartnersLoading: data.loading
    channelPartnersRefetch: data.refetch

#
# Mutations
#

import createChannelPartner from '/mutations/channel-partners/create.gql'
import updateChannelPartner from '/mutations/channel-partners/update.gql'
import deleteChannelPartner from '/mutations/channel-partners/delete.gql'

export withCreateChannelPartner = graphql createChannelPartner,
  props: ({ mutate })->
    createChannelPartner: (attrs)->
      {data: {channel_partner_create: {channel_partner, errors}}} = \
      await mutate variables: channel_partner: attrs
      {channel_partner, errors}

export withUpdateChannelPartner = graphql updateChannelPartner,
  props: ({ mutate })->
    updateChannelPartner: (id, attrs)->
      {data: {channel_partner_update: {channel_partner, errors}}} = \
      await mutate variables: {id: id, channel_partner: attrs}
      {channel_partner, errors}

export withDeleteChannelPartner = graphql deleteChannelPartner,
  props: ({ mutate })->
    deleteChannelPartner: (id)->
      {data: {channel_partner_delete: {channel_partner, errors}}} = \
      await mutate variables: {id}
      {channel_partner, errors}
